<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  watch: {
    $route: {
      handler(val, oldval) {
        setTimeout(() => {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }, 1000);
      },
      // 深度观察监听
      deep: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue